import React, { Ref } from 'react';

import styles from './TextAreaInput.module.scss';
interface TextAreaInputProps {
  value?: string;
  label?: string | null;
  onChange?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  onBlur?: (e: any) => void;
  hasError?: boolean;
  disabled?: boolean;
  required?: boolean;
  errorMessage?: string | undefined | any;
  placeholder?: string | null;
  autocomplete?: string;
  name?: string;
  type?: string;
  defaultValue?: string;
  rows?: number;
  cols?: number;
  icon?: React.ReactNode;
  ref?: Ref<HTMLInputElement>;
  horizontalResize?: boolean;
  verticalResize?: boolean;
}

export const TextAreaInput = React.forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  (
    {
      value,
      label,
      onChange,
      hasError = false,
      errorMessage,
      icon,
      disabled = false,
      onKeyDown,
      placeholder,
      name,
      required,
      onBlur,
      autocomplete,
      rows = 4,
      cols = 50,
      defaultValue,
      horizontalResize = false,
      verticalResize = false,
    },
    ref,
  ) => {
    const handleOnKeyDown = (e: any) => {
      if (e.key === 'Enter') {
        if (onKeyDown) {
          e.target.value = '';
          onKeyDown(e);
        }
      }
    };

    return (
      <div
        className={styles['text-area-input-container']}
        data-has-label={label !== undefined ? true : undefined}
      >
        {icon}
        <div className={styles['my-label']} data-has-label={label !== undefined ? true : undefined}>
          {label} {required && <b>*</b>}
        </div>

        <textarea
          className={styles['input']}
          ref={ref}
          value={value}
          onChange={onChange}
          data-has-error={hasError || !!errorMessage}
          data-has-icon={!!icon}
          disabled={disabled}
          name={name}
          placeholder={placeholder || ''}
          onKeyDown={handleOnKeyDown}
          onBlur={onBlur}
          autoComplete={autocomplete}
          rows={rows}
          cols={cols}
          defaultValue={defaultValue}
          data-horizontal-resize={horizontalResize}
          data-vertical-resize={verticalResize}
        />

        {errorMessage && <span className={styles['error']}>{errorMessage}</span>}
      </div>
    );
  },
);

TextAreaInput.displayName = 'TextAreaInput';

interface InputProps {
  hasError: boolean;
  hasIcon?: boolean;
  horizontalResize?: boolean;
  verticalResize?: boolean;
}

interface LabelProps {
  hasLabel?: boolean;
}
